/**
 * The reason each program is unavailable for a course because the program
 * does not serve the course's prefix, keyed by program type, read from the
 * server's verdict on GET /api/program/eligible/:courseId. The rule itself
 * lives on the server; this only words it for the program step.
 *
 * @param {object|null|undefined} eligibility - The endpoint's response.
 * @returns {Object<string, string>}
 */
export function subjectUnavailableReasons(eligibility) {
    const reasons = {};
    for (const programType of eligibility?.notServingSubject || []) {
        reasons[programType] = `Not offered for ${eligibility.subject} courses`;
    }
    return reasons;
}
